import React from 'react';
import { IconSuvFilled, IconCarFilled } from 'wg-fe-ui';

interface Props {
  category?: string | null;
  color?: string;
}

const CarCategoryIconSelector: React.FC<React.PropsWithChildren<Props>> = ({
  category,
  color,
}) => {
  switch (category) {
    case 'SUV':
      return <IconSuvFilled color={color} />;
    default:
      return <IconCarFilled color={color} />;
  }
};

export default CarCategoryIconSelector;
